import clsx from 'clsx';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function LoadingIcon(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/_jsxs("svg", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: clsx('text-primary-purple -ml-1 mr-3 h-8 w-8 animate-spin', className),
    children: [/*#__PURE__*/_jsx("path", {
      d: "M32 16c0 8.837-7.163 16-16 16S0 24.837 0 16 7.163 0 16 0s16 7.163 16 16ZM5.6 16c0 5.744 4.656 10.4 10.4 10.4 5.744 0 10.4-4.656 10.4-10.4 0-5.744-4.656-10.4-10.4-10.4-5.744 0-10.4 4.656-10.4 10.4Z",
      fill: "currentColor",
      className: "opacity-15"
    }), /*#__PURE__*/_jsx("path", {
      d: "M29.2 16c1.546 0 2.825-1.263 2.556-2.786A16.003 16.003 0 0 0 18.786.244C17.263-.025 16 1.254 16 2.8s1.276 2.763 2.766 3.175a10.4 10.4 0 0 1 7.26 7.259C26.435 14.724 27.653 16 29.2 16Z",
      fill: "currentColor"
    })]
  });
}